<script>
  import UserDetail from "./UserDetail.svelte";
  import ContactList from "./ContactList.svelte";
  import { onMount, afterUpdate } from "svelte";

  // Props
  let userImg;
  let name;
  let age;
  let region;
  let phone;
  let email;

  // Search bard properties
  let search = "";
  // Contact List properties
  let usersArray = [];
  let usersArrayMod = [];
  let regionsArray = [];
  let regionsArrayMod = [];
  let found = true;
  // Utility properties
  let selectedRegion;
  let selected = false;
  let cards;

  onMount(() => {
    //const data = requestData("https://uinames.com/api/?ext&amount=25");
    const data = requestData("./api.json");
    data.then(e => (usersArray = e)).catch(e => console.log(e));
  });

  async function requestData(url) {
    const request = await fetch(url);
    const data = await request.json();
    return data;
  }

  function makeSearchName(searchInput) {
    if (searchInput.length >= 1) {
      const filtered = usersArray.filter(e => {
        return (
          e.name.toLowerCase().includes(searchInput.toLowerCase()) ||
          e.surname.toLowerCase().includes(searchInput.toLowerCase())
        );
      });
      usersArrayMod = filtered;
      if (!usersArrayMod.length) {
        found = false;
      } else {
        found = true;
      }
    } else {
      usersArrayMod = [...usersArray];
    }
  }

  function filterRegionsInArray(array) {
    const set = new Set();
    array.forEach(el => {
      set.add(el.region);
    });
    regionsArray = [...Array.from(set)];
  }
  function filterRegionsInArrayMod(array) {
    const set = new Set();
    array.forEach(el => {
      set.add(el.region);
    });
    regionsArrayMod = [...Array.from(set)];
  }

  function selectRegion(regionSelected) {
    selected = true;
    const filtered = usersArray.filter(e => {
      return e.region.includes(regionSelected);
    });
    usersArrayMod = filtered;
  }

  function resetList() {
    usersArrayMod = [...usersArray];
    selected = false;
  }

  afterUpdate(() => {
    Array.from(cards.children[0].children).forEach(el => {
      el.addEventListener("click", function() {
        name =
          this.querySelector(".name").innerText +
          " " +
          this.querySelector(".surname").innerText;
        age = this.querySelector("[data-age]").getAttribute("data-age");
        region = this.querySelector(".region").innerText;
        phone = this.querySelector(".phone").innerText;
        email = this.querySelector("[data-email]").getAttribute("data-email");
        userImg = this.querySelector("[data-img]").getAttribute("data-img");
      });
    });

    filterRegionsInArray(usersArray);
    filterRegionsInArrayMod(usersArrayMod);
  });
</script>

<style>
  .main {
    display: flex;
    height: 100%;
  }

  .search-container {
    padding: 2.5rem;
    border-left: 1px solid #e1e1e1;
    flex: 1 0 75%;
    display: flex;
    flex-direction: column;
  }
  .form {
    position: relative;
    margin-bottom: 4.5rem;
  }
  .search-input {
    padding: 1.5rem;
    height: 4.5rem;
    width: 100%;
    border-radius: 3px;
    border: 1px solid #c7c3c3;
    position: absolute;
    top: 0;
    left: 0;
    color: #aaa;
  }

  .search-input:focus {
    outline: 1px solid var(--primary-color);
    color: #444;
  }

  .search-input:focus + .search-button {
    border-left: 1px solid var(--primary-color);
  }

  .search-input:focus + .search-button > .search-img {
    filter: brightness(100%);
  }

  .search-button {
    width: 4.5rem;
    height: 4.5rem;
    position: absolute;
    border: none;
    border-left: 1px solid #c7c3c3;
    top: 0;
    padding: 1rem;
    right: 0;
    background: transparent;
    cursor: pointer;
  }
  .search-button:focus {
    outline: 1px solid var(--primary-color);
  }

  .search-button:hover > .search-img {
    filter: brightness(100%);
  }
  .search-img {
    width: 100%;
    filter: brightness(140%);
    transition: filter 0.3s;
  }

  .contact-info {
    display: flex;
    margin: 2.5rem 0;
    align-items: center;
  }

  .contact-title {
    flex: 1 0 50%;
  }

  .contact-form {
    flex: 1 0 50%;
    display: flex;
    justify-content: flex-end;
  }

  .contact-form-region-container {
    display: flex;
    flex-direction: column;
    width: 50%;
  }

  .contact-label {
    font-size: 1.6rem;
    font-weight: normal;
    margin-bottom: 1rem;
    text-align: right;
  }

  .select-region {
    border-radius: 3px;
    border: 1px solid #e1e1e1;
    padding: 0.5rem;
    background: #f7f7f7;
  }

  .contact-title-h3 {
    font-size: 3rem;
    font-weight: lighter;
  }
  .reset {
    text-decoration: none;
    padding: 0.5rem 1.5rem;
    background: rgb(252, 42, 42);
    color: var(--white);
    height: 2.5rem;
    border-radius: 3px;
    display: block;
    font-size: 1.2rem;
    align-self: flex-end;
    margin-right: 1.5rem;
  }

  .reset:hover {
    background: rgb(180, 30, 30);
  }

  .contact-list-container {
    overflow-y: hidden;
  }

  @media only screen and (max-width: 950px) {
    .search-input {
      width: 90%;
      left: 10%;
    }
  }

  @media only screen and (max-width: 400px) {
    .search-input {
      width: 80%;
      left: 20%;
    }

    .contact-form-region-container {
      width: 70%;
    }

    .search-container {
      border-left: none;
    }
  }

  @media only screen and (max-width: 330px) {
    .contact-form-region-container {
      width: 80%;
    }

    .contact-title {
      align-self: flex-end;
    }
  }
</style>

<main class="main">
  <!-- Card for the user info -->
  <UserDetail {userImg} {name} {age} {region} {phone} {email} />

  <!-- Search container that will handle most of the logic in the app -->
  <div class="search-container">

    <!-- Form that will fetch the data -->
    <form class="form" on:submit={e => e.preventDefault()}>

      <input
        on:input={() => makeSearchName(search)}
        bind:value={search}
        class="search-input"
        type="text"
        placeholder="Type a name" />

      <button class="search-button">
        <img
          class="search-img"
          src="./Vector_search_icon.svg.png"
          alt="Search" />
      </button>
    </form>

    <!-- List of contacts -->

    <div class="contact-info">
      <div class="contact-title">
        <h3 class="contact-title-h3">Contacts</h3>
      </div>

      <form class="contact-form">
        {#if selected}
          <a on:click={resetList} href="javascript:void(0)" class="reset">
            Reset
          </a>
        {/if}
        <div class="contact-form-region-container">
          <label class="contact-label" for="select-region">
            Choose by region
          </label>

          <select
            on:change={() => {
              selectedRegion = this.options[this.selectedIndex].value;
              selectRegion(selectedRegion);
            }}
            id="select-region"
            class="select-region">
            {#if !usersArrayMod.length}
              {#each regionsArray as region}
                <option value={region}> {region} </option>
              {/each}
            {:else}
              {#each regionsArrayMod as region}
                <option value={region}> {region} </option>
              {/each}
            {/if}

          </select>
        </div>
      </form>
    </div>

    <div class="contact-list-container" bind:this={cards}>
      {#if !usersArrayMod.length}
        <ContactList {usersArray} {found} />
      {:else}
        <ContactList usersArray={usersArrayMod} {found} />
      {/if}
    </div>

  </div>

</main>
